import React from 'react';
import AccountingRouter from './AccountingRouter';
import { Layout } from 'antd';

const { Sider, Content } = Layout;

const AccountingEntryPoint = () => (
  <Layout style={{ minHeight: '100vh' }}>
    <Layout>
      <Content style={{ margin: '24px 16px 0', background: '#fff' }}>
        <AccountingRouter />
      </Content>
    </Layout>
  </Layout>
);

export default AccountingEntryPoint;
